<div class="d-flex pb-2">
    <div class="col-6 pe-2">
        <div (click)="navigateToAccount()" class="fw-bold btn btn-dashboard w-100 py-3 d-flex align-items-center justify-content-center">
            <div class="icp-icon-40 icp-account"></div>
            {{"dashboard-account" | translate}}
        </div>
    </div>
    <div class="col-6 ps-2">
        <div (click)="navigateToSupport()" class="fw-bold btn btn-dashboard w-100 py-3 d-flex align-items-center justify-content-center">
            <div class="icp-icon-40 icp-support"></div>
            {{"dashboard-support" | translate}}
        </div>
    </div>
</div>